/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ServicesWizard {
    'use strict';

    interface IServicesWizardController {
        closeContext: () => void;
    }

    class ServicesWizardController implements IServicesWizardController {

        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.plugins.servicesWizard.ServicesWizardService'
        ];

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IState,
            protected servicesWizardService: IServicesWizardService
        ) {
           
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

       
    }

    angular.module('meevo.plugins.servicesWizard')
        .controller('meevo.plugins.servicesWizard.servicesWizardController', ServicesWizardController);
}